import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { alertV2 } from "../../api/index.js";
import { parserAPI } from "../../utils/parser.jsx";
import ReceivedMessageContent from "./components/ReceivedMessageContent.jsx";
import SentMessageContent from "./components/SentMessageContent.jsx";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { formatDateYMD } from "../../utils/helper.jsx";

function MachineGPT() {
  const navigate = useNavigate();
  const params = useParams();
  const divRef = useRef(null);
  const { email } = useAuth();
  const [chats, setChats] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [activeOlder, setActiveOlder] = useState(false);
  const [showOlder, setShowOlder] = useState(true);
  const [message, setMessage] = useState("");
  const [counter, setCounter] = useState(0);
  const getAlert = async () => {
    const msg = await alertV2.getChatGeneral();
    const chat_data = await parserAPI(msg);
    console.log({ chat_data });
    if (chat_data.length === 0) {
      setChats([
        {
          created_at: new Date(),
          role: "assistant",
          content: `Ask me anything about your machine and dashboard. E.g. "Which Machines should I prioritize for maintenance services?"`,
        },
      ]);
      fillFirstQuestion();
    } else {
      const data = chat_data;
      const today = new Date();
      const existing = data.find(
        (d) => formatDateYMD(d.created_at) < formatDateYMD(today)
      );
      if (existing) {
        setActiveOlder(true);
      }
      // hideOlder(data);
      setChats(chat_data);
      setFiltered(chat_data);
      // get last data has action and come within 2 minutes
      const lastData = chat_data[chat_data.length - 1];
      if (lastData.action) {
        const lastDate = new Date(lastData.created_at);
        const diff = (today - lastDate) / 1000;
        if (diff < 120) {
          const action = lastData.action;
          if (action === "navigate") {
            const url = lastData.url;
            setTimeout(() => {
              navigate(url);
            }, 3000);
          }
        }
      }
    }
  };
  function hideOlder(data) {
    const today = new Date();
    const filter_date = data.filter(
      (d) => formatDateYMD(d.created_at) >= formatDateYMD(today)
    );
    setFiltered(filter_date);
  }
  function toggleOlder() {
    if (!showOlder) {
      setShowOlder(true);
      setFiltered(chats);
    } else {
      // hideOlder(chats);
      setShowOlder(false);
    }
  }
  useEffect(() => {
    setCounter(1);
  }, []);
  useEffect(() => {
    if (counter === 1) {
      getAlert();
    }
  }, [counter]);
  useEffect(() => {
    setTimeout(() => {
      scrollBottom();
    }, 500);
  }, [filtered]);
  function scrollBottom() {
    const scrollHeight = divRef.current.scrollHeight;
    const height = divRef.current.clientHeight;
    const maxScrollTop = scrollHeight - height;
    divRef.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  }
  async function fillFirstQuestion() {
    const payload = {
      alert_id: params.alertId,
      content: `Ask me anything about your machine and dashboard. E.g. "Which Machines should I prioritize for maintenance services?"`,
      role: "assistant",
    };
    const msg = await alertV2.addChat(params.alertId, payload);
  }
  function handleChange(event) {
    setMessage(event.target.value);
  }
  // async function handleSubmit(event) {
  //   const pesan = message;
  //   setMessage("");
  //   event.preventDefault();
  //   let newChat = filtered;
  //   newChat.push({
  //     id: "ba6bf34e-2e68-4c2b-aeaf-7dd1ea964cfb",
  //     created_at: new Date(),
  //     content: pesan,
  //     role: "user",
  //     user_id: "almarai",
  //     alert_id: null,
  //     user: {
  //       username: "almarai",
  //       email: "almarai@groundup.ai",
  //       firstname: "qatar",
  //       lastname: "almarai",
  //       is_staff: false,
  //       password:
  //         "$2a$12$TTp2YXGZHKVDHZ.dLA4Fzunt2CQcwM.CsAFgHnBUZ7nO6ofsAa3uW",
  //       job_title: "test",
  //       reset_password_token: null,
  //       role_id: "4eaaf42b-5ec0-44d6-9af6-26dca27d4cde",
  //     },
  //   });
  //   newChat.push({
  //     id: "25a04cf1-b128-4bd1-89e4-efb11a92ea76",
  //     created_at: new Date(),
  //     content:
  //       "I will show you the page where you can find the solution to your question",
  //     role: "assistant",
  //     user_id: "almarai",
  //     alert_id: null,
  //     user: {
  //       username: "almarai",
  //       email: "almarai@groundup.ai",
  //       firstname: "qatar",
  //       lastname: "almarai",
  //       is_staff: false,
  //       password:
  //         "$2a$12$TTp2YXGZHKVDHZ.dLA4Fzunt2CQcwM.CsAFgHnBUZ7nO6ofsAa3uW",
  //       job_title: "test",
  //       reset_password_token: null,
  //       role_id: "4eaaf42b-5ec0-44d6-9af6-26dca27d4cde",
  //     },
  //   });
  //   setFiltered(newChat);
  //   if (pesan.toLowerCase().includes("temperature")) {
  //     setTimeout(() => {
  //       navigate(
  //         "/machine/live-data/6b85a858-cd7e-43ea-8352-5627b90e5e4e?temperature=1"
  //       );
  //     }, 3000);
  //   }
  //   if (pesan.toLowerCase().includes("health")) {
  //     setTimeout(() => {
  //       navigate("/dashboard/machine-health?machine=All");
  //     }, 3000);
  //   }
  //   if (pesan.toLowerCase().includes("online")) {
  //     setTimeout(() => {
  //       navigate("/machine/list");
  //     }, 3000);
  //   }
  // }
  async function handleSubmit(event) {
    const pesan = message;
    setMessage("");
    event.preventDefault();
    const payload = {
      content: pesan,
      email: email,
      role: "user",
    };
    const msg = await alertV2.addChatGeneral(payload);
    const payload_gina = [];
    chats.map((chat) => {
      payload_gina.push({
        role: chat.role,
        content: chat.content,
      });
    });
    payload_gina.push({
      role: "user",
      content: pesan,
    });
    const chat_gina = {
      messages: payload_gina,
    };
    await getAlert();
    const chat_data = await alertV2.askGinaGeneral(chat_gina);
    await getAlert();
  }
  return (
    <div>
      {/*{activeOlder && (*/}
      {/*  <div*/}
      {/*    className="show-older"*/}
      {/*    style={{ color: "black" }}*/}
      {/*    onClick={toggleOlder}*/}
      {/*  >*/}
      {/*    {!showOlder ? "Show" : "Hide"} Previous Chat*/}
      {/*  </div>*/}
      {/*)}*/}
      <div
        className="chat-placeholder"
        ref={divRef}
        style={{
          background: "#343e4a",
          borderRadius: "10px",
          marginTop: "10px",
          padding: "5px",
        }}
      >
        <div className="widget-chat">
          {filtered.map((chat, index) => {
            return (
              <div key={index} className="widget-chat-item">
                {chat?.role === "user" ? (
                  <SentMessageContent message={chat} />
                ) : (
                  <ReceivedMessageContent message={chat} />
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className="input-group">
        <input
          value={message}
          onChange={handleChange}
          type="text"
          className="form-control"
          placeholder="Enter Chat..."
        />
        <button
          className="btn btn-outline-default"
          type="button"
          onClick={handleSubmit}
        >
          <i className="fa fa-paper-plane text-muted"></i>
        </button>
      </div>
    </div>
  );
}
export default MachineGPT;
